import { useEffect, useState } from "react";
import axios from "axios";
import { BookOpen, Loader2, FileText, Download } from "lucide-react";
import TabManual from "@/components/admin/TabManual";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TAB_KEYS = [
  "dashboard", "bookings", "contacts", "agreements", "fleet", "share",
  "reviews", "money", "customers", "availability", "recovery", "analytics", "drivers", "citations", "rewards",
];

export default function HelpManual({ token }) {
  const [manuals, setManuals] = useState(null);

  useEffect(() => {
    axios.get(`${API}/manuals`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setManuals(r.data))
      .catch(() => setManuals({}));
  }, [token]);

  return (
    <div data-testid="help-manual" className="space-y-6">
      <div>
        <h2 className="font-display font-black text-2xl flex items-center gap-2"><BookOpen className="text-[#F2B705]" size={22} /> Admin User Manual</h2>
        <p className="text-white/45 text-sm mt-1">The full guide for every tab in one place. Click any section to expand, and use "Edit this guide" to customize the instructions — only you (logged in) can change them.</p>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3 bg-[#0C0C0C] border border-[#F2B705]/25 rounded-lg px-4 py-3">
        <div>
          <p className="font-semibold text-[#F2B705] flex items-center gap-2"><FileText size={16} /> Master Rental Agreement (blank)</p>
          <p className="text-white/45 text-xs mt-0.5">The official blank template for court, law enforcement, or printing.</p>
        </div>
        <a data-testid="master-agreement-btn-help" href={`${API}/master-agreement.pdf`} target="_blank" rel="noreferrer"
          className="flex items-center gap-2 bg-[#F2B705] text-black text-sm font-bold px-4 py-2 rounded-md hover:bg-white transition-colors">
          <Download size={15} /> View / Print Master Copy
        </a>
      </div>

      {!manuals ? (
        <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#F2B705]" /></div>
      ) : (
        <>
          <TabManual tabKey="help" token={token} defaultOpen initialManual={manuals["help"]} />
          <div className="space-y-3">
            {TAB_KEYS.map((k) => (
              <TabManual key={k} tabKey={k} token={token} initialManual={manuals[k]} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
